<div class="wchfs-chip-wrapper">
  <div #content class="wchfs-chip-content">
    <ng-content></ng-content>
  </div>
  <div (click)="onChipRemove()" *ngIf="removable" class="wchfs-chip-x">
    <wchfs-icon svgIcon="wchfs:chip-cross"></wchfs-icon>
  </div>
</div>
